export const RECEIVE_COURSE_CAMPAIGNS = 'RECEIVE_COURSE_CAMPAIGNS';
export const SORT_CAMPAIGNS_WITH_STATS = 'SORT_CAMPAIGNS_WITH_STATS';
export const SORT_ALL_CAMPAIGNS = 'SORT_ALL_CAMPAIGNS';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const ADD_CAMPAIGN = 'ADD_CAMPAIGN';
export const RECEIVE_ALL_CAMPAIGNS = 'RECEIVE_ALL_CAMPAIGNS';
export const RECEIVE_CAMPAIGNS_WITH_STATS = 'RECEIVE_CAMPAIGNS_WITH_STATS';
